import React, {forwardRef, useEffect, useRef} from "react";
import {Checkbox} from "@mui/material";

const TableCheckbox = forwardRef(({indeterminate, ...rest}, ref) => {
  const defaultRef = useRef();
  const resolvedRef = ref || defaultRef;

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return (
    <>
      <Checkbox
        ref={resolvedRef}
        {...rest}
        size="small"
        sx={{
          p: "4px",
        }}
      />
    </>
  );
});

export default TableCheckbox;
